import { ExperienceType } from 'src/context/experience';
import { isNotProduction } from 'src/utils/env/isNotProduction';
import { followLocalsFeatureFlags } from './followLocalsFeatureFlags';

export const isSpanishTargetLocale = (locale: string | null | undefined): boolean => {
  if (!locale) return false;
  const code = locale.toLowerCase();
  return code === 'es' || code.startsWith('es-');
};

export interface FollowLocalsGateInput {
  experienceLoaded: boolean;
  experienceType: ExperienceType | null;
  eligibilityLoading: boolean;
  isEligibleForPathways: boolean;
  languagePairLoading: boolean;
  targetLanguageLocale: string | null | undefined;
}

/** Spanish Path learners only, and only outside production while the speakers are placeholders. */
export const getFollowLocalsGate = (
  input: FollowLocalsGateInput,
): { pending: boolean; eligible: boolean } => {
  const enabled = followLocalsFeatureFlags.enabledOutsideProduction && isNotProduction();
  if (!enabled) return { pending: false, eligible: false };

  if (!input.experienceLoaded || input.eligibilityLoading || input.languagePairLoading) {
    return { pending: true, eligible: false };
  }

  const eligible =
    input.experienceType === '2025' &&
    input.isEligibleForPathways &&
    isSpanishTargetLocale(input.targetLanguageLocale);

  return { pending: false, eligible };
};
